<div class="timer-container">
	Current Time <span #clock></span> <span class="ddos-info-200">&nbsp;{{ systemTimezone }} </span>
	/
	<span #clock1> </span><span class="ddos-info-200">&nbsp;{{ UTCTimezone }}</span>
</div>
